import {Component, OnInit} from '@angular/core';
import {EventBusService} from "../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {BaseComponent} from "../../../base/components/base.component";
import {SubscriptionContainerService} from "../../../base/services/subscription-container.service";
import {AuthService} from "../../../modules/common/modules/auth/services/auth.service";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends BaseComponent implements OnInit {


  constructor(
    eventBus: EventBusService,
    router: Router,
    subContainer: SubscriptionContainerService,
    private authService: AuthService,
  ) {
    super(eventBus, router, subContainer)
  }

  protected componentName(): string {
    return LogoutComponent.name;
  }

  ngOnInit(): void {
    this.logout()
  }


  logout(): void {
    if (!confirm("Are you sure you want to logout?")) return
    this.authService.logout()
  }

}
